import { selectors } from '@elab/core/store/order';
import { actions as uiActions, selectors as uiSelectors } from '@elab/core/store/ui';
import connect from '@elab/core/store/connect';

import { DisplayStores } from '../store-locator/shop/DisplayStores';

const mapStateToProps = state => {
    return {
        currentStoreInfo: selectors.getDeliveryPointOfService(state),
        stores: selectors.getEntries(state),
        storeInfoPopupOpened: uiSelectors.getOpenStoreInfo(state),
    };
};

const mapDispatchToEvents = dispatch => ({
    'close-store-info': () => dispatch(uiActions.storeInfoStatus(false)),
});

export default () =>
    customElements.define(
        'e2-order-display-stores',
        connect(mapStateToProps, mapDispatchToEvents)(DisplayStores),
    );
